import { Component, Inject, Input } from '@angular/core';
import { Router } from '@angular/router';
import { MODAL_EVENT_OPEN, MODAL_EVENT_CLOSE, DwMenuService, DwMenuServiceState, DwSecurityUserService, DwAuthenticationType, DwSecurityStateService, DevwareUiMetaDataRegistrationService, DwEventService, DwOrmDataService, DwMetaDataService, DwMetaDataServiceToken, areEqual } from '@devwareapps/devware-cap';
import { environment } from 'src/environments/environment';
import { AviatorUser } from '../../features/shared/models/aviator-user.model';
import { DwThemeManagerService } from '@devwareapps/devware-cap/devware-admin/themes-admin/services/dw-theme-manger.service';
import { SchoolBrandingService } from '../../features/schools/services/school-branding.service';
import { AdminManagerService } from '../../features/admin/services/admin-manager.service';
import { SchoolSelectionModalActionService } from '../../features/admin/actions/school-select-modal-action.service';
import { AppPermissions } from '../../meta-data/app-permissions.enum';
import { AppMetaData, AppMetaDataLookups } from '../../meta-data/app-meta-data.service';
import { delay } from 'rxjs/operators';
import { AppDevwareConfigProviderService } from '../../app-devware-config-provider.service';
import { HelpScoutBeaconService } from '../../features/help-scout-beacon/services/help-scout-beacon.service';
import { SchoolRepositoryService } from '../../features/schools/services/school-repository.service';
import { SchoolFeatures } from 'c:/Projects/DevwareGit/AviatorOnline/AviatorOnlineCAPAngular/src/app/features/schools/models/school-features.model';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  showLayout: boolean = true;

  showSplashScreen: boolean = true;
  environmentMessage: string;
  scrolled = false;

  courseSideBarClass = '';

  themeClasses: string;

  showSideLogo: boolean = true;

  currentUser: AviatorUser;
  flightSchoolName: string = 'Aviator Pro';
  logoutComplete: boolean;
  flightSchoolOverridden: boolean = true;

  @Input() registrationItems = false;
  @Input() registrationActions = false;
  schoolFeatures: SchoolFeatures;

  initialThemeComplete = false;
  lastSecurityState: any;

  constructor(
    private router: Router,
    private menuService: DwMenuService,
    private dwSecurityUserService: DwSecurityUserService,
    private schoolBrandingService: SchoolBrandingService,
    private adminManagerService: AdminManagerService,
    private schoolSelectModalActionService: SchoolSelectionModalActionService,
    private dwSecurityStateService: DwSecurityStateService,
    private devwareUiMetaDataRegistrationService: DevwareUiMetaDataRegistrationService,
    private dwEventService: DwEventService,
    private schoolRepository: SchoolRepositoryService,
    @Inject(DwMetaDataServiceToken) private dwMetaDataService: DwMetaDataService,
    private helpScoutBeaconService: HelpScoutBeaconService

  ) {

    if (this.registrationItems) {
      console.log('Register Items');
      this.devwareUiMetaDataRegistrationService.registerItems();
    }

    if (this.registrationActions) {
      console.log('Register Actions');
      this.devwareUiMetaDataRegistrationService.registerActions();
    }
  }

  ngOnInit(): void {
    const environmentConfigItem = AppDevwareConfigProviderService.getEnvironmentConfigItem();
    this.environmentMessage = environmentConfigItem.envMessage;

    this.initFlightSchoolFeatures();

    const bodyClasses = document.body.classList;

    this.dwSecurityUserService.securityContextChanged().subscribe(change => {
      const state = this.dwSecurityStateService.securityState;

      if (state.isAuthenticating || state.isRefreshing) {
        console.log('Show Splash screen');
        this.showSplashScreen = true;
        return;
      }

      console.log('Security Context Changed', state);

      let forceSetTheme = false;
      if (this.lastSecurityState && this.lastSecurityState.isAuthenticated != state.isAuthenticated) {
        // authentication state changed
        if (state.isAuthenticated) {

          console.log('Reset App Setup Complete');
          forceSetTheme = true;

          setTimeout(() => {
            this.appSetupComplete = false;
            this.showSplashScreen = true;
            console.log('Show splash screen');
            this.initialThemeComplete = false;

            // Refreshes the themese and remove the app-setup-complete class so the splash screen can show
            this.updateThemes(this.themeClasses);
          });
        }
      }

      this.lastSecurityState = state;

      this.loadFlightSchoolFeatures(forceSetTheme);
      //this.setTheme(this.menuService.menuState);
    });

    this.menuService.menuStateObservable
      .subscribe(menuState => {
        this.setTheme(menuState);
      });

    this.dwEventService.getEvent(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(AppMetaData.FlightSchool.ItemDetail.itemName))
      .pipe(delay(300))
      .subscribe((flightSchool) => {
        // console.log('Flight School Changed, updating name', flightSchool);
        // this.currentUser = this.adminManagerService.getAviatorUser(this.dwSecurityUserService.securityState?.securityContext?.ApplicationUser);
        // this.flightSchoolName = this.currentUser?.FlightSchoolName;
        this.loadFlightSchoolFeatures();
      });

    // Initial setup before security context is loaded
    this.finalSetTheme(this.menuService.menuState);

    this.setTheme(this.menuService.menuState);

    this.helpScoutBeaconService.setupBeaconEvents();
  }

  loadingFeatures = false;
  reloadFeatures = false;

  initFlightSchoolFeatures() {
    try {
      // const schoolFeaturesJson = sessionStorage.getItem('schoolFeatures');

      // if (schoolFeaturesJson) {
      //   this.schoolFeatures = JSON.parse(schoolFeaturesJson);
      //   this.flightSchoolName = this.schoolFeatures.FlightSchoolName;

      //   return;
      // }

      this.loadFlightSchoolFeatures();

    } catch (e) {

    }
  }

  storeFlightSchoolFeatures() {
    try {
      if (!this.schoolFeatures) {
        return;
      }

      sessionStorage.setItem('schoolFeatures', JSON.stringify(this.schoolFeatures));
    } catch (e) {

    }
  }

  loadFlightSchoolFeatures(forceSetTheme: boolean = false) {
    if (this.dwSecurityUserService.securityState.isAuthenticating || this.dwSecurityUserService.securityState.isRefreshing) {
      return;
    }

    if (this.schoolFeatures && this.currentUser?.FlightSchoolId != this.schoolFeatures?.FlightSchoolId) {
      if (this.loadingFeatures) {
        this.reloadFeatures = true;
        return;
      }

      this.reloadFeatures = false;
      this.loadingFeatures = true;
      this.schoolRepository.refreshSchoolFeatures()
        .subscribe((features => {
          this.setSchoolFeatures(features, forceSetTheme);

          this.loadingFeatures = false;
        }));
    }

    if (this.loadingFeatures) {
      return;
    }

    this.reloadFeatures = false;

    this.schoolRepository.getSchoolFeatures()
      .subscribe((features) => {
        this.setSchoolFeatures(features);

        this.loadingFeatures = false;

        if (this.reloadFeatures) {
          this.loadFlightSchoolFeatures();
        }
      });
  }

  private setSchoolFeatures(schoolFeatures: SchoolFeatures, forceSetTheme: boolean = false) {
    // If nothings changed, don't do anything
    if (!forceSetTheme && areEqual(this.schoolFeatures, schoolFeatures)) {

      if (this.reloadFeatures) {
        this.loadingFeatures = false;
        this.loadFlightSchoolFeatures();
        return;
      }

      return;
    }
    if (!schoolFeatures) {
      console.warn('School features are null - not good!');
      return;
    }

    console.log(`School Features loaded for School Id:${schoolFeatures.FlightSchoolId}  Theme Id: ${schoolFeatures.FlightSchoolThemeId}`);

    this.loadingFeatures = false;

    this.schoolFeatures = schoolFeatures;
    this.flightSchoolName = schoolFeatures.FlightSchoolName;

    this.storeFlightSchoolFeatures();

    this.setTheme(this.menuService.menuState);

    if (this.reloadFeatures) {
      setTimeout(() => {
        this.loadingFeatures = false;
        this.loadFlightSchoolFeatures();
        return;
      });
    }
  }

  changeSchool() {
    if (this.adminManagerService.canChangeFlightSchool()) {
      this.schoolSelectModalActionService.handleAction(null).subscribe(() => {
        this.loadFlightSchoolFeatures();
      });
    }
  }

  private annonymousSetupStarted = false;
  oldUser: AviatorUser;

  private setTheme(menuState: DwMenuServiceState) {

    this.currentUser = this.adminManagerService.getAviatorUser(this.dwSecurityUserService.securityState?.securityContext?.ApplicationUser);

    if (this.oldUser?.FlightSchoolId != this.currentUser?.FlightSchoolId || (this.currentUser?.FlightSchoolId && this.currentUser?.FlightSchoolId != this.schoolFeatures?.FlightSchoolId)) {
      this.oldUser = this.currentUser;

      this.loadFlightSchoolFeatures();

      return;
    }

    this.oldUser = this.currentUser;

    this.flightSchoolOverridden = (this.currentUser.RealFlightSchoolId != this.currentUser.FlightSchoolId);

    this.schoolBrandingService.setupSchoolBranding(this.currentUser, this.schoolFeatures)
      .subscribe((applyingBrandingChange) => {
        if (!applyingBrandingChange) {
          this.finalSetTheme(menuState);

          if (!this.initialThemeComplete) {
            this.initialThemeComplete = true;
            console.log('Hide splash scree');
          }

          this.showSplashScreen = false;
          console.log('School branding setup complete', applyingBrandingChange);
        }
      });
  }

  private appSetupComplete = false;
  private updateThemes(...themes: string[]) {

    if (this.appSetupComplete) {
      themes.push('app-setup-complete');
    }

    const newThemes = themes.join(',');

    if (this.themeClasses != newThemes) {
      this.themeClasses = newThemes;
      //console.log('Theme Classes', this.themeClasses);
    }
  }

  private finalSetTheme(menuState: DwMenuServiceState) {
    //console.log('Final Set Theme');
    const currentMenu = menuState.currentMenu;

    if (!this.appSetupComplete) {
      setTimeout(() => {

        this.appSetupComplete = true;
        this.updateThemes(this.themeClasses);
      }, 50);
    }

    this.showSideLogo = !(menuState?.currentMenu?.url?.indexOf('my-courses/') >= 0);

    let themeClass = Themes.home;

    themeClass = Themes.main;

    if (currentMenu?.url?.indexOf('admin') >= 0) {
      themeClass = Themes.admin;
    }

    if (currentMenu?.data?.referenceKey == 'home') {
      themeClass = Themes.home;
    }

    this.themeClasses = themeClass;

    if (this.scrolled) {
      this.updateThemes(themeClass, 'scrolled');
    } else {
      this.updateThemes(themeClass, 'scrolled');
    }

    this.courseSideBarClass = '';
    if (currentMenu?.url.indexOf('courses/view/') >= 0) {
      this.courseSideBarClass = 'course-side-bar-width';
    }

    if (!this.dwSecurityUserService.securityState.isAuthenticated) {

      if (this.dwSecurityUserService.securityState.authenticationType == DwAuthenticationType.logout && !this.logoutComplete) {

        setTimeout(() => {
          this.updateThemes(this.themeClasses, 'home-page-annonymous');
          //   this.themeClasses += ',home-page-annonymous';
          // console.log('theme Classes', this.themeClasses);
          this.logoutComplete = true;

        }, 250);
        return;
      } else {
        this.updateThemes(this.themeClasses, 'home-page-annonymous');
        //this.themeClasses += ',home-page-annonymous';
      }
    } else {
      this.logoutComplete = false;
    }

    // console.log('theme Classes', this.themeClasses);

    this.deselectText();
  }

  private deselectText() {
    try {
      if (window.getSelection) {
        window.getSelection().removeAllRanges();
      }
      else
        if ((document as any).selection) {
          (document as any).selection.empty();
        }
    }
    catch (e) {

    }
  }

  ngOnDestroy(): void {
    document.removeEventListener("scroll", (ev) => { });
  }

}


enum Themes {
  home = 'home-theme',
  main = 'main-theme',
  admin = 'admin-theme'
}
